export default {
  'example': {
    'title': 'Example title'
  },
  'error': {
    'title': 'Error'
  }
}
